import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

const arrowHeight = 40;

const baseStyles = {
    container: {
        marginTop: 10,
        backgroundColor: '#FFFFFF',
        borderRadius: 4
    },
    arrowIcon: {
        position: 'absolute',
        top: -25,
        right: 0,
        width: arrowHeight,
        height: arrowHeight
    }
};

if (Device.isTabletOrWeb) {
    baseStyles.container = {
        ...baseStyles.container,
        width: 300
    };
}

export default StyleSheet.create(baseStyles);
